import dayjs from "dayjs";
import OpeningTime, { OpeningTimeDto } from "./OpeningTime";
import { TIME_MASK_ZEROHOUR_ZEROMINUTES_24H } from "../Forms/Constants/TimeConstants";
import { WeekDaysEnum } from "./WeekDays";
import { defaultBreakStartTime } from "../Forms/OpeningTimes/openingTimeDateUtils";

export class OpeningTimeMapper {
  static toWriteDto = (openingTime: OpeningTime, openingTimeId: number): OpeningTimeDto => {
    return {
      Id: openingTimeId,
      ParentId: openingTime.ParentId,
      HasBreak: openingTime.HasBreak,
      OpeningHour: dayjs(openingTime.StartTime).format(TIME_MASK_ZEROHOUR_ZEROMINUTES_24H),
      ClosingHour: dayjs(openingTime.EndTime).format(TIME_MASK_ZEROHOUR_ZEROMINUTES_24H),
      BreakStartTime: openingTime.HasBreak
        ? dayjs(openingTime.BreakStartTime).format(TIME_MASK_ZEROHOUR_ZEROMINUTES_24H)
        : undefined,
      BreakDuration: openingTime.HasBreak
        ? dayjs(openingTime.BreakDuration, TIME_MASK_ZEROHOUR_ZEROMINUTES_24H).diff(
            dayjs().startOf("day"),
            "minute"
          )
        : 0,
      OpeningDays: WeekDaysEnum.toBitmask(openingTime.WeekDays),
    };
  };

  static toOpeningTimes = (openingTimes: OpeningTimeDto[]): OpeningTime[] => {
    return openingTimes?.map((openingTime: OpeningTimeDto) => {
      return {
        Id: openingTime.Id,
        ParentId: openingTime.ParentId,
        HasBreak: openingTime.HasBreak,
        StartTime: dayjs(openingTime.OpeningHour, TIME_MASK_ZEROHOUR_ZEROMINUTES_24H),
        EndTime: dayjs(openingTime.ClosingHour, TIME_MASK_ZEROHOUR_ZEROMINUTES_24H),
        BreakStartTime: openingTime.HasBreak
          ? dayjs(openingTime.BreakStartTime, TIME_MASK_ZEROHOUR_ZEROMINUTES_24H)
          : defaultBreakStartTime(),
        BreakDuration: openingTime.HasBreak
          ? dayjs().startOf("day").add(openingTime.BreakDuration, "minute").format("HH:mm")
          : "00:30",
        WeekDays: WeekDaysEnum.fromBitmask(openingTime.OpeningDays),
        IsNew: false,
      };
    });
  };
}
